import { ConfirmModal } from "mobily-ui-library"
import { useGlobalStore } from "../stores/globalStore";
import { useShallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";
import Antenna_mast from "../assets/Antenna_mast.svg";


export const CoverageError = () => {

    const { t } = useTranslation();
    const { lang, setCoverageError } = useGlobalStore(
        useShallow((state) => ({
            lang: state.lang,
            setCoverageError: state.setCoverageError,
        }))
    );

    const handleRequestCoverage = () => {
        window.open((window as any)["new_request_url"], "_blank");
    }
    const handleGotoAirFiber = () => {
        window.open((window as any)["air_fiber_url"], "_blank");
    }
    const rtl = lang === 'ar' ? true : false;
    return (
        <div className='coverageErrorWrapper'>
            <ConfirmModal
                title={t("fiber_coverage_not_available")}
                subTitle={t("fiber_coverage_request_new")}
                buttonName={t("fiber_coverage_home_5g_button")}
                outlineButtonName={t("fiber_coverage_request_button")}
                showOutlineButton={true}
                showButton={true}
                showIcon={true}
                icon={Antenna_mast}
                rtl={rtl}
                classNameTitle='errorTitle'
                classNameSubText='errorSubText'
                primaryButtonclassName='errorPrimaryButton'
                outlineButtonclassName='errorOutlineButton'
                onClickClose={() => setCoverageError(false)}
                onclickButton={handleGotoAirFiber}
                onclickOutLineButton={handleRequestCoverage}
            />
        </div>
    )
}